import ScatterJS from "scatterjs-core";
import ScatterEOS from "scatterjs-plugin-eosjs";
import Eos from "eosjs";

ScatterJS.plugins(new ScatterEOS());

// main
const network = ScatterJS.Network.fromJson({
    blockchain: "eos",
    chainId: "aca376f206b8fc25a6ed44dbdc66547c36c6c33e3a119ffbeaef943642f0e906",
    host: "eospush.tokenpocket.pro",
    port: 443,
    protocol: "https"
});

// jungle
// const network = ScatterJS.Network.fromJson({
//     blockchain: "eos",
//     chainId: "e70aaab8997e1dfce58fbfac80cbbb8fecec7b99cf982a9444273cbc64c41473",
//     host: "jungle2.cryptolions.io",
//     port: 443,
//     protocol: "https"
// });

const requiredFields = {
    accounts: [network]
};

const mixin = {
    data() {
        return {
            scatter: null,
            currentAccount: null,
            currentPermission: null,
            msg: '',
            readonlyEos: ''
        }
    },
    created: function () {
        this.readonlyEos = Eos({
            httpEndpoint: network.protocol + "://" + network.host,
            chainId: network.chainId
        });

        try {
            if (typeof window !== undefined && window.scatter) {
                this.scatter = window.scatter;
                this.login();
            } else {
                ScatterJS.connect("AccountInfo", {
                    network
                }).then(connected => {
                    if (!connected) return console.error("no scatter");

                    this.scatter = ScatterJS.scatter;

                    this.login();
                });
            }
        } catch (err) {
            this.handleError(err);
        }



    },
    methods: {
        login() {
            if (this.scatter) {
                this.scatter
                    .getIdentity(requiredFields)
                    .then(identity => {

                        this.currentAccount = identity.accounts[0].name;
                        this.currentPermission = identity.accounts[0].authority;
                        this.scatter['eosClient'] = this.scatter.eos(network, Eos);
                        this.getBaseInfo();
                    })
                    .catch(err => {
                        this.handleError(err);
                    });
            }
        },
        logout() {
            if (this.scatter) {
                this.scatter.forgetIdentity();
                this.currentAccount = null;
                this.currentPermission = null;
            }
        },
        handleError(err) {
            let errorMsg = err;

            if (typeof err === "string") {
                try {
                    let errJson = JSON.parse(err);
                    if (errJson.error && errJson.error.details.length) {
                        errorMsg = errJson.error.details[0].message;
                    } else if (errJson.error) {
                        errorMsg = errJson.error.what;
                    } else {
                        errorMsg = errJson.message || errJson.code || errJson.msg;
                    }
                } catch (e) {
                    errorMsg = e;
                }
            } else {
                errorMsg = err.message || err.type || err.code;
            }
            this.msg = errorMsg;
            this.$modal.show("message");
        }
    }
}

export default mixin;